import React, { useContext, useRef, useState, useEffect } from "react";
import Navbar from "./select-components/navbar-select";
import PageHeader from "./global-components/page-header";
import Footer from "./select-components/footer-select";
import EmpresaContext, { EnviarContato } from "../context";
import { Link } from "react-router-dom";
import { HBT } from "../builder-context";
import InputMask from "react-input-mask";

function validateEmail(email) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}
const Contact = ({ initialState }) => {
  const [uid, setuid] = useState(null);
  const [nome, setnome] = useState(initialState ? initialState.nome : "");
  const [telefone, settelefone] = useState("");
  const [email, setemail] = useState(initialState ? initialState.email : "");
  const [text, setText] = useState(initialState ? initialState.text : "");

  let context = useContext(EmpresaContext);
  let firstInputRef = useRef(null);

  React.useEffect(() => {
    setuid(
      sessionStorage.getItem("uid") || localStorage.getItem("uid") || null
    );
  }, []);

  async function onConfirm() {
    const empresa = context;

    try {
      //https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
      if (!validateEmail(email)) {
        return alert("O email enviado é inválido!");
      }
      if (!telefone.match(/^\([0-9]{2}(?:\))\s?[0-9]{5}(?:-)[0-9]{4}$/)) {
        return alert("Insira um telefone válido!");
      }
      let cliente = {
        foto: null,
        nome,
        email,
        created_at: new Date(),
        DDD: telefone.slice(1, 3),
        telefone: telefone.slice(5),
        CPF: null,
        FGTS: null,
        conjuge_nome: "",
        corretor_responsavel: null,
        dependentes: null,
        entrada: 1,
        imoveis_cadastrados: [],
        imoveis_visitados: [],
        visitante_id: localStorage.getItem("visitante_id"),
        possui_emprestimo: false,
        renda: null,
        proprietario: false,
        status: "Cadastrado recentemente",
        timeline: [
          {
            descrição: "Parabéns! Mais um cliente na sua lista!",
            titulo: "Cliente cadastrado!",
            data: new Date()
          }
        ],
        troca: false,
        utilizar_financiamento: false
      };
      if (text) {
        cliente.timeline.push({
          descrição: text,
          titulo: "Mensagem",
          data: new Date()
        });
      }
      let uid = await EnviarContato({ empresa_id: empresa.db_id, cliente });
      if (typeof uid === "string") {
        // localStorage.setItem("uid", uid);
        window.location.reload();
      }
    } catch (error) {
      console.log(error);
    }
  }
  return (
    <div>
      <Navbar />
      <PageHeader
        backgroundImage={
          context.info_gen["image-header-pages"] ||
          context.banner[1] ||
          context.banner[0] ||
          "#"
        }
        headertitle="Contato"
      />
      <div className="contact-area pd-top-100 pd-bottom-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="section-title pd-left mb-0">
                <h5 className="sub-title" {...HBT("bb_sub_contact")}>
                  {context["bb_sub_contact"] ||
                    "Preencha o formulário e receba um atendimento ágil!"}
                </h5>
                <h2 className="title">Entre em contato!</h2>
                <p {...HBT("bb_p_contact")}>
                  {context["bb_p_contact"] ||
                    "Quer um atendimento especial? Preencha o formulário e entraremos em contato o mais rápido possivel!"}
                </p>
                {/* <span
                  className="btn btn-yellow"
                  onClick={() => firstInputRef.current.focus()}
                >
                  Enviar contato
                </span> */}
              </div>
            </div>
            <div className="col-lg-4">
              <div className="contact-form-wrap contact-form-bg">
                {uid && (
                  <>
                    <h4>Seu contato foi enviado!</h4>
                    <div className="btn-wrap text-center">
                      <Link className="btn btn-yellow" to={"/"}>
                        Voltar
                      </Link>
                    </div>
                  </>
                )}
                {!uid && (
                  <>
                    <div className="rld-single-input">
                      <input
                        type="text"
                        value={nome}
                        onChange={e => setnome(e.target.value)}
                        placeholder="Nome"
                        name="name"
                        autoComplete={"name"}
                        ref={firstInputRef}
                      />
                    </div>
                    <div className="rld-single-input">
                      <InputMask
                        id="Telefone"
                        name="suffix"
                        onChange={e => settelefone(e.target.value)}
                        value={telefone}
                        placeholder="Telefone"
                        mask="(99) 99999-9999"
                        autoComplete={"tel"}
                      />
                    </div>
                    <div className="rld-single-input">
                      <input
                        type="text"
                        value={email}
                        onChange={e => setemail(e.target.value)}
                        placeholder="Email"
                        name="email"
                        autoComplete={"email"}
                      />
                    </div>
                    <div className="rld-single-input">
                      <textarea
                        type="text"
                        value={text}
                        onChange={e => setText(e.target.value)}
                        placeholder="Mensagem"
                        name={"mensagem"}
                        autoComplete={"mensagem"}
                      />
                    </div>
                    <div className="btn-wrap text-center">
                      <button onClick={onConfirm} className="btn btn-yellow">
                        Enviar contato
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="row pd-left pd-top-92">
            <div className="col-xl-2 col-sm-6">
              {context.telefones_empresa &&
              context.telefones_empresa.length > 0 ? (
                <div className="single-contact-info">
                  <p>
                    <i className="fa fa-phone" />
                    Ligue para a gente:
                  </p>
                  {context.telefones_empresa.map(tel => (
                    <h5 key={tel.telefone}>
                      <p>{tel.nome}</p>
                      {tel.telefone}
                    </h5>
                  ))}
                </div>
              ) : context.telefones_empresa &&
              context.telefones_empresa.length > 0 ? (
                <div className="single-contact-info">
                  <p>
                    <i className="fa fa-phone" />
                    Ligue para a gente:
                  </p>
                  {context.telefones_empresa.map(tel => (
                    <h5 key={tel}>{tel}</h5>
                  ))}
                </div>
              ) : (
                ""
              )}
            </div>
            {context.email && (
              <div className="col-xl-4 col-sm-6">
                <div className="single-contact-info">
                  <p>
                    <i className="fa fa-envelope" />
                    Contato por email
                  </p>
                  <h5>{context.email}</h5>
                </div>
              </div>
            )}
            {context.endereço && (
              <div className="col-xl-3 col-sm-6">
                <div className="single-contact-info">
                  <p>
                    <i className="fa fa-phone" />
                    Endereço
                  </p>
                  <h5>{context.endereço}</h5>
                </div>
              </div>
            )}
            {context.horario_funcionamento && (
              <div className="col-xl-3 col-sm-6">
                <div className="single-contact-info">
                  <p>
                    <i className="fa fa-phone" />
                    Horario de Atendimento
                  </p>
                  <h5>{context.horario_funcionamento}</h5>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Contact;
